import { StyledButton } from "./styles";
import { ButtonProps } from "../types";

export const Button = ({ color, children, onClick, variant = "primary", type = "button" }: ButtonProps) => (
  <StyledButton color={color} onClick={onClick} variant={variant} type={type}>
    {children}
  </StyledButton>
);
